import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-customer-layout',
  templateUrl: './customer-layout.component.html',
  styleUrls: ['./customer-layout.component.scss']
})
export class CustomerLayoutComponent implements OnInit {
  loadPageData(): void {}

  ngOnInit(): void {
    this.loadPageData();
  }
}
